<template>
  <div v-if="supportcategory !== null">
    <!-- 分類 -->
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="supportcategory.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px mr-5">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px my-n2">
            <v-autocomplete
              v-model="supportcategory.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- 群組 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>群組</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            :items="supportTypeOptions"
            v-model="supportcategory.type"
            placeholder="請選擇群組"
            class="w-240px"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <!-- Template -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Marketing Tools Template</h4>
          <div class="h5 ink-02-medium--text">
            使用於MARKETING TOOLS顯示方式為表格型態 or 圖片縮圖
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-radio-group v-model="supportcategory.data_template" row>
            <div
              v-for="uploadType in [
                {
                  label: 'Table',
                  value: 'table',
                },
                {
                  label: 'Photo',
                  value: 'photo',
                },
              ]"
              :key="uploadType.value"
              class="w-50"
            >
              <v-radio class="mr-01" :value="uploadType.value">
                <template v-slot:label>
                  <div class="ink-01-emphasis--text w-202px">
                    {{ uploadType.label }}
                  </div>
                </template>
              </v-radio>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="supportcategory.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="supportcategory.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="supportcategory.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="supportcategory.cover_image"
            dir="SupportCategory"></ImgUploader>
        </div>
      </div>
      <!-- Banner圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Banner圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於內頁頁面 <br />
            建議尺寸：1000px * 1000px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="supportcategory.detail_page_banner"
            dir="SupportCategory"></ImgUploader>
        </div>
      </div>
      <!-- 副標題 (沿用資料庫既有的 description 欄位，沒有另外開新欄位；改標籤是為了避免被誤用成長篇說明文字) -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4 class="mb-2">副標題 (Subtitle)</h4>
          <div class="h5 ink-02-medium--text">
            顯示於前台 Services 選單，請簡短填寫，不是長篇說明文字
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="supportcategory.description"
            outlined
            dense
            rows="2"
          ></v-textarea>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
  },
  data: () => ({
    type: '',
    status: true,
    bu: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState(['buTabs']),
    ...mapState('supportcategory', ['supportcategory', 'supportTypeOptions']),
  },
};
</script>

<style></style>
